import { Div, Button, Input } from '@codesuma/baseline'
import { EventFreq } from '../../services/event-repeat'
import { IChoice } from '../../components/wizard'
import { Draft } from './draft'
import wizard from '../../components/wizard/index.module.css'
import style from './index.module.css'

export const FREQ_CHOICES: IChoice<EventFreq>[] = [
    { value: 'none', label: 'تکرار نمی‌شود' },
    { value: 'daily', label: 'هر روز' },
    { value: 'weekly', label: 'هر هفته' },
    { value: 'monthly', label: 'هر ماه' },
    { value: 'yearly', label: 'هر سال' },
]

const stepBody = (title: string) => {
    const base = Div()
    base.addClass(wizard.body)
    const heading = Div(title)
    heading.addClass(wizard.stepTitle)
    base.append(heading)
    return base
}

// How often it comes back. The choices are the step; the two details under them
// only appear once one of them repeats, so a one-off never has to read past
// them.
export const RepeatSlide = (draft: Draft) => {
    const base = stepBody('هر چند وقت تکرار می‌شود؟')
    const changed = () => base.emit('change')

    const group = Div()
    group.addClass(wizard.choices)
    group.attr('role', 'radiogroup')
    group.attr('aria-label', 'تکرار')
    base.append(group)

    const extra = Div()
    extra.addClass(style.repeatExtra)
    base.append(extra)

    const syncExtra = () => extra.style({ display: draft.freq === 'none' ? 'none' : '' })

    const rows: { row: ReturnType<typeof Button>, value: EventFreq }[] = []
    for (const choice of FREQ_CHOICES) {
        const row = Button()
        row.addClass(wizard.choice)
        row.attr('role', 'radio')
        const label = Div(choice.label)
        label.addClass(wizard.choiceLabel)
        row.append(label)

        const sync = (on: boolean) => {
            row.toggleClass(wizard.choiceOn, on)
            row.attr('aria-checked', String(on))
        }
        sync(choice.value === draft.freq)

        row.on('click', () => {
            for (const other of rows) {
                other.row.toggleClass(wizard.choiceOn, other.value === choice.value)
                other.row.attr('aria-checked', String(other.value === choice.value))
            }
            sync(true)
            draft.freq = choice.value
            syncExtra()
            changed()
        })
        group.append(row)
        rows.push({ row, value: choice.value })
    }

    const extraRow = (label: string, control: ReturnType<typeof Div>) => {
        const row = Div()
        row.addClass(style.field)
        const name = Div(label)
        name.addClass(style.label)
        row.append(name, control)
        extra.append(row)
    }

    const interval = Input('', 'number', { value: draft.interval, min: 1, max: 99 })
    interval.addClass(wizard.field)
    interval.on('input', ({ value }: { value: string }) => {
        draft.interval = Math.max(1, Number(value) || 1)
        changed()
    })
    extraRow('هر چند بار یک‌بار', interval)

    const until = Input('', 'date', { value: draft.until })
    until.addClass(wizard.field)
    until.on('input', ({ value }: { value: string }) => {
        draft.until = value
        changed()
    })
    extraRow('تا تاریخ (اختیاری)', until)

    syncExtra()
    return base
}
